import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output, inject } from '@angular/core';
import { FormGroup, FormGroupDirective, ReactiveFormsModule } from '@angular/forms';
import { AddSmartSearchDialogFormSpecifySearch } from '@platform/smart-search/utils/formUtils';
import { FormFieldWrapperComponent } from '@shared-lib/components/form-components/form-field-wrapper/form-field-wrapper.component';
import { InputTextComponent } from '@shared-lib/components/form-components/input-text/input-text.component';
import { SelectButtonComponent } from '@shared-lib/components/form-components/select-button/select-button.component';
import { SliderComponent } from '@shared-lib/components/form-components/slider/slider.component';
import { mortgageInterestRateSelectItems } from '@shared-lib/options/mortgage-interest-rate-select-items';
import { StepperComponent } from '@shared/components/stepper/stepper.component';

@Component({
  selector: 'cp-add-smart-search-specify-search',
  imports: [StepperComponent, FormFieldWrapperComponent, ReactiveFormsModule, SliderComponent, SelectButtonComponent, InputTextComponent],
  templateUrl: './add-smart-search-specify-search.component.html',
  styleUrls: ['../add-smart-search-dialog-step.component.scss', './add-smart-search-specify-search.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AddSmartSearchSpecifySearchComponent implements OnInit {
  @Input({ required: true }) formGroupName: string;
  @Input({ required: true }) isSaving: boolean;
  @Input() isBackButtonVisible = true;
  @Output() nextClicked = new EventEmitter();
  @Output() backClicked = new EventEmitter();

  private readonly rootFormGroup = inject(FormGroupDirective);

  protected stepFormGroup: FormGroup<AddSmartSearchDialogFormSpecifySearch>;
  protected readonly mortgageInterestRateSelectItems = mortgageInterestRateSelectItems;

  ngOnInit(): void {
    this.stepFormGroup = this.rootFormGroup.control.get(this.formGroupName) as FormGroup<AddSmartSearchDialogFormSpecifySearch>;
  }

  emitNextClicked(): void {
    if (this.stepFormGroup.valid) {
      this.nextClicked.emit();
    }
  }

  emitBackClicked(): void {
    this.backClicked.emit();
  }
}
